import React, { useEffect, useState } from "react";
import { Box, Paper, Typography, Grid } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ContactsIcon from "@mui/icons-material/Contacts";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";

const Dashboard = () => {
  const [statsData, setStatsData] = useState({
    sentWhatsapp: 0,
    failedWhatsapp: 0,
    activeContacts: 0,
    inactiveContacts: 0,
  });

  const fetchStats = async () => {
    try {
      // Sent WhatsApp
      const sentSnap = await getDocs(
        query(collection(db, "whatsapphistory"), where("status", "==", "sent"))
      );

      // Failed WhatsApp
      const failedSnap = await getDocs(
        query(collection(db, "whatsapphistory"), where("status", "==", "failed"))
      );

      // Active Contacts
      const activeSnap = await getDocs(
        query(collection(db, "contacts"), where("status", "==", "Active"))
      );

      // Inactive Contacts
      const inactiveSnap = await getDocs(
        query(collection(db, "contacts"), where("status", "==", "Inactive"))
      );

      setStatsData({
        sentWhatsapp: sentSnap.docs.length,
        failedWhatsapp: failedSnap.docs.length,
        activeContacts: activeSnap.docs.length,
        inactiveContacts: inactiveSnap.docs.length,
      });
    } catch (err) {
      console.error("Dashboard Error:", err);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const stats = [
    {
      title: "Sent WhatsApp",
      value: statsData.sentWhatsapp,
      bg: "linear-gradient(135deg, #25D366, #1FAA59)",
      icon: <WhatsAppIcon sx={{ fontSize: 35 }} />,
    },
    {
      title: "Failed WhatsApp",
      value: statsData.failedWhatsapp,
      bg: "linear-gradient(135deg, #e53935, #ef5350)",
      icon: <WhatsAppIcon sx={{ fontSize: 35 }} />,
    },
    {
      title: "Active Contacts",
      value: statsData.activeContacts,
      bg: "linear-gradient(135deg, #1976d2, #42a5f5)",
      icon: <ContactsIcon sx={{ fontSize: 35 }} />,
    },
    {
      title: "Inactive Contacts",
      value: statsData.inactiveContacts,
      bg: "linear-gradient(135deg, #9e9e9e, #bdbdbd)",
      icon: <ContactsIcon sx={{ fontSize: 35 }} />,
    },
  ];

  return (
    <Box>
      <Typography
        variant="h5"
        fontWeight="900"
        mb={3}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          position: "relative",
          paddingLeft: "10px",
          "&::before": {
            content: '""',
            width: "4px",
            height: "100%",
            backgroundColor: "#1976d2",
            position: "absolute",
            left: "0",
            borderRadius: "4px",
          },
        }}
      >
        Dashboard
      </Typography>

      <Grid className="row" spacing={3}>
        {stats.map((item, idx) => (
          <Grid className="col-sm-3 mb-3" key={idx}>
            <Paper
              elevation={6}
              sx={{
                p: 2,
                borderRadius: 2,
                textAlign: "center",
                color: "#fff",
                background: item.bg,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: "pointer",
                transition: "0.3s",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.35)",
                },
              }}
            >
              {item.icon}
              <Typography variant="subtitle2" fontWeight="600" sx={{ mt: 1 }}>
                {item.title}
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {item.value}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Dashboard;
